import React from "react";
import "./head.scss";
import { IMG } from "..";
import selfPhoto from "../../images/ben.jpg";
import selfPhotoWebp from "../../images/1701280251347.jpeg";
import { Link } from "react-router-dom";

const Head = React.memo(function Head() {
  return (
    <section className="head-container">
      <Link to="/">
        <IMG src={selfPhoto} srcwebp={selfPhotoWebp} alt="Orkun Tümer" />
      </Link>
      <h1 className="head-name">Orkun Tümer</h1>
      <h2 className="head-title">Engineer of Web & Mobile Experiences</h2>
      <hr />
    </section>
  );
});

export { Head };
